import { render, staticRenderFns } from "./PriceWorkflowViewPromo.vue?vue&type=template&id=5fa21aa4&scoped=true&"
import script from "./PriceWorkflowViewPromo.vue?vue&type=script&lang=js&"
export * from "./PriceWorkflowViewPromo.vue?vue&type=script&lang=js&"
import style0 from "./PriceWorkflowViewPromo.vue?vue&type=style&index=0&id=5fa21aa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa21aa4",
  null
  
)

export default component.exports